import React, { useEffect, useState } from 'react'
import { ErrorAlert } from 'components/errorAlert/ErrorAlert'
import { getTranslation } from 'utils/translation'

export const ErrorChunk = () => {
  const [countdown, setCountdown] = useState(10)

  useEffect(() => {
    const interval = setInterval(() => {
      setCountdown((prev) => prev - 1)
    }, 1000)

    const timeout = setTimeout(() => {
      window.location.reload()
    }, countdown * 1000)

    return () => {
      clearInterval(interval)
      clearTimeout(timeout)
    }
  }, [])

  return (
    <ErrorAlert
      title={getTranslation('resource', 'FEATURE_UPDATE_ANNOUNCEMENT')}
      errorCode="update"
      buttonTitle={`${getTranslation('message', 'ERROR.REFRESH', [`${countdown}`, 'SECOND_S'])}`}
      onClick={() => window.location.reload()}
    >
      <p>
        {getTranslation('message', 'ERROR.NEW_FEATURES')}
        <br />
        {getTranslation('message', 'ERROR.REFRESH_PAGE')}
      </p>
    </ErrorAlert>
  )
}
